import {inject, Injectable} from '@angular/core';
import {MessageViewModel} from '../view-models/message-view.model';
import {DateFormatterService} from '@shared/services/date-formatter.service';
import {ConversationDetailMessageDTO} from '@dto/messaging/conversation-detail-message-dto.model';
import {AttachmentViewModel} from '../view-models/attachment-view.model';
import {ConversationDetailMessageAttachmentDTO} from '@dto/messaging/conversation-detail-message-attachment-dto.model';
import {Utils} from '@shared/utilities/utils';

@Injectable({
  providedIn: 'root'
})
export class MessageConverterService {
  private readonly dateFormatterService = inject(DateFormatterService);

  convert(messages: ConversationDetailMessageDTO[]): MessageViewModel[] {
    return messages.map(m => ({date: new Date(m.timestamp), message: m}))
      .sort((a, b) => a.date.valueOf() - b.date.valueOf())
      .map(w => this.convertSingle(w.message));
  }

  convertSingle(message: ConversationDetailMessageDTO): MessageViewModel {
    const createdDateTime = new Date(message.timestamp);
    const timestamp: string = this.dateFormatterService.formatDateTime(createdDateTime);
    const messageAttachments: AttachmentViewModel[] = this.convertAttachments(message.attachments);

    return {
      sender: message.sender,
      timestamp: timestamp,
      content: message.content,
      messageNumber: message.messageNumber,
      showAttachments: false,
      attachments: messageAttachments,
      isOwnMessage: message.isOwnMessage
    };
  }

  private convertAttachments(attachments: ConversationDetailMessageAttachmentDTO[]): AttachmentViewModel[] {
    return attachments.map(a => this.convertSingleAttachment(a));
  }

  private convertSingleAttachment(attachment: ConversationDetailMessageAttachmentDTO): AttachmentViewModel {
    const extension = Utils.getFormattedFileExtension(attachment.extension).toLowerCase();
    const iconUrl = Utils.getFileIconSource(extension);
    return {
      ...attachment,
      iconUrl: iconUrl
    };
  }
}
